import React, { useEffect, useLayoutEffect } from 'react';
import Amplitude from 'utils/amplitude';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import { ButtonGroup, RequestActionView, Spacer } from 'design-system';
import { claimRedemptions, getRedemptions } from 'actions';
import { goBackWithKey } from 'utils/navigationv6';
import EmptyComponent from 'design-system/EmptyComponent';
import { useAppDispatch } from 'store/hooks';
import IconGift from 'design-system/icons/IconGift';
import { getReferrals, payReferral } from 'features/inviteFriend/actions';
export const strings = {
    button: 'Amazing, let’s go back!',
    title: 'Your money is on the way!',
    subTitle: 'We are processing your request now. Your reward should be in your paypal account shortly.',
};
const ClaimRewardCompletedScreen = ({ route, navigation, }) => {
    const dispatch = useAppDispatch();
    useLayoutEffect(() => {
        navigation.setOptions({
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, []);
    const { email, isClaimingReferral } = route.params;
    useEffect(() => {
        if (isClaimingReferral) {
            dispatch(payReferral({ email })).then((response) => {
                dispatch(getReferrals());
                return response;
            });
            return;
        }
        dispatch(claimRedemptions({ email })).then((response) => {
            dispatch(getRedemptions());
            return response;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onPressClaim = () => {
        const keyBack = route.params?.keyBack;
        if (keyBack) {
            goBackWithKey(navigation, keyBack);
        }
        else {
            navigation.popToTop();
        }
        Amplitude.logEvent('ClaimRewards.ClickOnRewardClaimed');
    };
    return (<RequestActionView renderIcon={() => (<>
          <IconGift colorKey="brand" height={84} width={84}/>
          <Spacer h={16}/>
        </>)} renderTitle={() => (<Text Text-24 centered>
          {strings.title}
        </Text>)} renderSubTitle={() => (<Text TextThin-16 Secondary centered>
          {strings.subTitle}
        </Text>)}>
      <ButtonGroup type="floating">
        <Button brand title={strings.button} onPress={onPressClaim}/>
      </ButtonGroup>
    </RequestActionView>);
};
export default ClaimRewardCompletedScreen;
